export const clearHash = () => {
  if (window.location.hash) {
    const cleanUrl = window.location.href.split('#')[0]
    window.history.replaceState(null, '', cleanUrl)
  }
}
